import { useState, useEffect } from "react";
import {
  Box,
  Button,
  TextField,
  Typography,
} from "@mui/material";
import React from "react";
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Autocomplete from '@mui/material/Autocomplete';
import { GridColDef, GridRowParams, MuiEvent } from '@mui/x-data-grid';
import { createTheme } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import axios from "axios";
import { useForm, Resolver, SubmitHandler } from "react-hook-form";
import Chip from '@mui/material/Chip';
import IconButton from '@mui/material/IconButton';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import CloseIcon from '@mui/icons-material/Close';
import SmartphoneIcon from '@mui/icons-material/Smartphone';
import EmailIcon from '@mui/icons-material/Email';
import Link from '@mui/material/Link';
import { IUser } from "../../interfaces/IUser";
import { ICrew } from "../../interfaces/ICrew";
import { alpha, styled } from '@mui/material/styles';
import { DataGrid, gridClasses } from '@mui/x-data-grid';
import { setPageTitle } from "../../slices/applicationSlice";
import { IApplication } from "../../interfaces/IApplication";
import { useAppDispatch } from "../../hooks";
import ActionButton from "../../components/ActionButton";
import ActionMenu from "../../components/ActionMenu";
import GroupAddIcon from '@mui/icons-material/GroupAdd';

const ODD_OPACITY = 0.2;

const StripedDataGrid = styled(DataGrid)(({ theme }) => ({
  [`& .${gridClasses.row}.even`]: {
    backgroundColor: theme.palette.grey[300],
    '&:hover, &.Mui-hovered': {
      backgroundColor: alpha(theme.palette.primary.main, ODD_OPACITY),
      '@media (hover: none)': {
        backgroundColor: 'transparent',
      },
    },
    '&.Mui-selected': {
      backgroundColor: alpha(
        theme.palette.primary.main,
        ODD_OPACITY + theme.palette.action.selectedOpacity,
      ),
      '&:hover, &.Mui-hovered': {
        backgroundColor: alpha(
          theme.palette.primary.main,
          ODD_OPACITY +
          theme.palette.action.selectedOpacity +
          theme.palette.action.hoverOpacity,
        ),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: alpha(
            theme.palette.primary.main,
            ODD_OPACITY + theme.palette.action.selectedOpacity,
          ),
        },
      },
    },
  },
}));


const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

export interface DialogTitleProps {
  id: string;
  children?: React.ReactNode;
  onClose: () => void;
}

function BootstrapDialogTitle(props: DialogTitleProps) {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
}





type Anchor = 'top' | 'left' | 'bottom' | 'right';



const resolver: Resolver<ICrew> = async (values) => {
  return {
    values: values.name ? values : {},
    errors: !values.name
      ? {
        name: {
          type: 'required',
          message: 'This is required.',
        },
      }
      : {},
  };
};

export default function Crews() {

  function CrewClicked(_event: React.MouseEvent<HTMLElement>): void {
    
    setOpen(true);
  }

  

  const [open, setOpen] = useState(false);

  function handleClose() {
    setOpen(!open);
  }

  const buttons = [
    <ActionButton action={CrewClicked} buttonLabel="ADD NEW CREW" />,
    
    
  ];


  const dispatch = useAppDispatch();

  useEffect(() => {
    let appState: IApplication = {
      pageTitle: "Crew Management",
      backgroundPath: "/assets/images/growing.jpg"
    }
    dispatch(setPageTitle(appState));
  }, []);

  const [state, setState] = React.useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
  });

  const [rows, setRows] = useState<ICrewRow[]>([]);
  const [users, setUsers] = useState<IUser[]>([]);
  const [currentUser, setCurrentUser] = useState<IUser>();
  const [currentCrew, setCurrentCrew] = useState<ICrew>();
  const [selectedUsers, setSelectedUsers] = useState<IUser[]>([]);
  useEffect(() => {
    GetGridData(setRows);
    axios.get(`${process.env.REACT_APP_ENDPOINT}/api/Users`).then(x => {
      setUsers(x.data);
    })
  }, []);

  useEffect(() => {
    console.log("IN CURRENT USER");
    if (currentUser != undefined) {
      let users = [...selectedUsers, currentUser]
      console.log("USERS", users);
      setSelectedUsers(users);
    }
    setCurrentUser(undefined);
  }, [currentUser])



  const { register, handleSubmit, control, formState: { errors }, reset, setValue, getValues } = useForm<ICrew>({ resolver });

  const onSubmit: SubmitHandler<ICrew> = data => {
    console.log("In Submit");
    if (data.id > 0) {
      axios.put(`${process.env.REACT_APP_ENDPOINT}/api/Crews/${data.id}`, {
        id: data.id,
      }).then((data) => {
        console.log(data);
        if (data.status === 204) {
          reset();
          setOpen(false);
          GetGridData(setRows);
        };
      });
    } else {
      axios.post(`${process.env.REACT_APP_ENDPOINT}/api/Crews`, {
        name: data.name,
        userCrews: selectedUsers,
        active: data.active,
        notes: data.notes,
        createdAt: new Date(),
        updatedAt: new Date()
      }).then((data) => {
        console.log(data);
        if (data.status === 201) {
          reset();
          setOpen(false);
          GetGridData(setRows);
        };
      });
    }
  };

  

  
  const [helpOpen, setHelpOpen] = React.useState(false);

  const handleClickOpen = () => {
    reset();
    setOpen(true);
  };

  const handleClickHelpOpen = () => {
    setHelpOpen(true);
  };

  const handleHelpClose = () => {
    setHelpOpen(false);
  };

  

  const handleDoubleClick = (x: GridRowParams<any>, y: MuiEvent<React.MouseEvent<HTMLElement, MouseEvent>>) => {
    console.log(x.row.active);
    setValue('id', x.row.id);
    // setValue('employeeId', x.row.employeeId);
    // setValue('firstName', x.row.firstName);
    // setValue('lastName', x.row.lastName);
    // setValue('userName', x.row.userName);
    // setValue('phone', x.row.phone);
    // setValue('email', x.row.email);
    // setValue('password', x.row.password);
    // setValue('passwordHint', x.row.passwordHint);
    // setValue('notes', x.row.notes);
    // setValue('active', x.row.active);
    setOpen(true);
  }



  const columns: GridColDef[] = [
    //{ field: 'id', headerName: 'ID', width: 50, hide: true },
    { field: 'idNumber', headerName: 'ID Number', width: 150 },
    { field: 'name', headerName: 'Crew Name', width: 150 },
    { field: 'userCrews', headerName: 'Users', width: 500 },
    { field: 'notes', headerName: 'Notes', width: 150 },
  ];

  interface ICrewRow {
    id: number,
    idNumber: string,
    name: string,
    userCrews: string[],
    notes: string,
  }

  const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#010101' : '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
    border: 0,
    borderRadius: 0,
    boxShadow: "none",
  }));

  const darkTheme = createTheme({
    palette: {
      mode: 'dark',
      primary: {
        main: '#89B219',
      },
    },
  });

  const handleDelete = (props: IUser) => {
    var users = selectedUsers.filter(obj => {
      return obj.id != props.id
    });
    setSelectedUsers(users);
  };

  function GetGridData(setRows: React.Dispatch<React.SetStateAction<ICrewRow[]>>) {
    console.log(process.env.REACT_APP_ENDPOINT);
    axios
      .get(`${process.env.REACT_APP_ENDPOINT}/api/Crews`)
      .then(res => {
        var rowResult: ICrewRow[] = [];
        for (let index = 0; index < res.data.length; index++) {
          const element: ICrew = res.data[index];
          var nameResults = element.userCrews.map(x => { return x.user?.fullName });
          console.log("Name Results", nameResults);
          rowResult.push({
            id: element.id,
            idNumber: "",
            name: element.name,
            userCrews: nameResults !== undefined ? nameResults as string[] : [],
            notes: ""
          })
        }
        console.log(rowResult);
        setRows(rowResult);
      });
  }

  return (
    <div>
     <ActionMenu buttons={buttons} />
      <Grid container spacing={0} bgcolor="#101010" >
        <Grid item xs={12}>
          <Item>
            <div style={{ height: 'calc(100vh - 76px)', width: '100%' }}>
              <StripedDataGrid
                rows={rows}
                columns={columns}
                pageSize={20}
                rowsPerPageOptions={[20]}
                sx={{ borderColor: 'rgba(100,100,100,0.2)' }}
                onRowDoubleClick={(x, y) => handleDoubleClick(x, y)}
                getRowClassName={(params) =>
                  params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'
                }
              />
            </div>
          </Item>
        </Grid>
      </Grid>

      <div>
        <BootstrapDialog
          onClose={handleHelpClose}
          aria-labelledby="customized-dialog-title"
          open={helpOpen}
        >
          <BootstrapDialogTitle id="customized-dialog-title" onClose={handleHelpClose}>
            Need Support?
          </BootstrapDialogTitle>
          <DialogContent dividers>
            <Typography sx={{ mb: 3 }} variant="body2" gutterBottom>
              If you are having issues or have questions, please contact us below.
            </Typography>
            <Button size='large' fullWidth variant="contained" startIcon={<SmartphoneIcon />} sx={{ mb: 1, bgcolor: '#89B219' }}>
              <Link href="tel:8003141797" underline="none" color="#FFF"><Typography variant='h6' fontWeight={700}>800-314-1797</Typography></Link>
            </Button>
            <Button size='large' fullWidth variant="contained" startIcon={<EmailIcon />} sx={{ mb: 1, bgcolor: '#89B219' }}>
              <Link href="mailto:bobs-market@idatp.com" underline="none">
                <Typography variant='h6' fontWeight={700} color="#FFF">bobs-market@idatp.com</Typography></Link>
            </Button>
          </DialogContent>
        </BootstrapDialog>
      </div>

      <Dialog open={open} onClose={handleClose} maxWidth='lg' fullWidth>
        <DialogTitle>Create New Crew</DialogTitle>
        <Box component="form" onSubmit={handleSubmit(onSubmit)}>
          <DialogContent>
            <TextField id="id" label="id" variant="outlined" fullWidth sx={{ display: 'none' }} {...register("id")} />
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <Item>
                  <TextField label="Crew Name" variant="outlined" fullWidth {...register("name")} />
                </Item>
              </Grid>
              <Grid item xs={12}>
                <Item>
                  <TextField label="Notes" variant="outlined" fullWidth {...register("notes")} />
                </Item>
              </Grid>
              <Grid item xs={12}>
                <Item>
                  <Autocomplete
                    value={currentUser}
                    options={users}
                    getOptionLabel={(option) => `${option.id}: ${option.firstName} ${option.lastName}`}
                    onChange={(_, data) => {
                      setCurrentUser(data!);
                    }}
                    renderInput={(params) => (
                      <TextField key={params.id} {...params} fullWidth variant="filled" label="Users"></TextField>
                    )}
                  />
                </Item>
              </Grid>
              <Grid item xs={11}>
                {selectedUsers.map(function (object, i) {
                  return (
                    <Chip color="primary" label={`${object.firstName} ${object.lastName}`} onDelete={() => handleDelete(object)} />
                  )
                })}
              </Grid>
              <Grid item xs={1}>
                <Item>
                  <FormControlLabel
                    control={<Switch color="secondary" {...register("active")} />}
                    label="Active"
                    labelPlacement="top"
                  />
                </Item>
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose}>Cancel</Button>
            {getValues("id")
              ? <Button variant="contained" color="success" onClick={handleClose}>UPDATE</Button>
              : <Button variant="contained" color="success" onClick={handleSubmit(onSubmit)}>CREATE</Button>
            }
          </DialogActions>
        </Box>
      </Dialog>
    </div>
  );
}

